import type { FaireProductEntity } from "../../entity_types/product";

export const p_kfrjx5gqx3: FaireProductEntity = {
  token: "p_kfrjx5gqx3",
  type: "product",
  name: "Aperol Spritz Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9957c8de3ba4b2272d5b372857f4d2e31dc6faac7a8f76b44f9e2b80102dcab7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5018c2960413416c21f006df09590b8bce05d4e227892cb08f59dbca4587b12c.jpeg",
    "https://cdn.faire.com/fastly/c18bfb8b1ce5e5f286fc0f30040c091506fe0d3a3ec891dc80c049ace1b5a4b0.jpeg",
    "https://cdn.faire.com/fastly/2385ebebcdf4448430ec32c16bc8f618736ec9c391349dbbdc52216f37eacf2d.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:50.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
